module.exports = __webpack_public_path__ + "static/media/certification-close.f49c9505.svg";